import dayjs from 'dayjs';
import * as React from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import Checkbox from '../../components/common/checkbox';
import DatePicker from '../../components/common/DatePicker';
import IconButton from '../../components/common/IconButton';
import AxiosConfig from '../../utilities/AxiosConfig';
import Dialog from '../../utilities/Dialog';
import { LedgerReferenceType, LedgerType, PTOSnapshotType } from './types';
import axios from 'axios';
import './EditRequest.css';

var utc = require('dayjs/plugin/utc');
dayjs.extend(utc);

type PtoType = {
    ledger: Array<LedgerType>;
    pending: Array<number>;
    snapshot: PTOSnapshotType;
    ArchivedYears: string[]
};

interface IProps {
    availableHours: number;
    usersPTOPlan: any;
    maxDailyPTOHours: number;
    closeModal: any;
    userInfo: any;
    ledgerReference: any;
    refreshPTOInfo: any;
    toEdit: any;
    isOwnPTO: boolean;
    //bk 4/14/2022
    sortablePtoData: LedgerType[];
    ptoData: PtoType
    setPtoData: React.Dispatch<React.SetStateAction<PtoType>>
}

const oneDay: number = 1000 * 60 * 60 * 24;

const AddRequest: React.FC<IProps> = (props: IProps) => {
    const { maxDailyPTOHours, closeModal, ledgerReference, availableHours, refreshPTOInfo, toEdit, isOwnPTO, sortablePtoData, ptoData, setPtoData } = props;
    const [saving, setSaving] = React.useState(false);
    const [isAllDay, setIsAllDay] = React.useState(toEdit?.quantity >= maxDailyPTOHours);
    const [numOfDays, setNumOfDays] = React.useState(1);
    const [entryType, setEntryType] = React.useState(null as any);
    const [newEntry, setNewEntry] = React.useState({ ...toEdit, } as any);
    // const [newEntry, setNewEntry] = React.useState(toEdit ? { ...toEdit, } : {} as any);
    const [ptoUser, setPtoUser] = React.useState({} as any);
    const handleIsAllDayToggle = async () => {
        let updatedEntry: any = { ...newEntry };
        const nextState: boolean = !isAllDay;
        let numberOfDays: number = (newEntry.endTimets - newEntry.startTimets) / oneDay;
        if (numberOfDays > 1 && !nextState) {
            const alert: any = new Dialog({ type: "alert", message: "Multiple days can only be entered as All Day." });
            await alert.show();
            return;
        } else if (nextState && updatedEntry.quantity < maxDailyPTOHours) {
            updatedEntry.quantity = maxDailyPTOHours;
        } else if (!nextState && updatedEntry.quantity >= maxDailyPTOHours) {
            updatedEntry.quantity = 0;
        }
        setIsAllDay(nextState);
    }

    const handleDateChange = async (value: any, name: string) => {
        let updatedEntry = { ...newEntry };
        const selectedDate: any = value.valueOf();
        //? Changing all dates not just entry
        updatedEntry.entryDatets = selectedDate;
        updatedEntry.startTimets = selectedDate;
        updatedEntry.endTimets = dayjs.utc(selectedDate).hour(23).minute(59).second(0).millisecond(0).valueOf();
        let numberOfDays: number = (updatedEntry.endTimets - updatedEntry.startTimets) / oneDay;
        setNumOfDays(numberOfDays);
        if (numberOfDays > 1 || isAllDay) {
            setIsAllDay(true);
            if (numberOfDays < 0) {
                updatedEntry.quantity = 0;
            } else {
                updatedEntry.quantity = maxDailyPTOHours * Math.round(numberOfDays);
            }
        }
        setNewEntry(updatedEntry);
    }

    const handleChange = (e: any) => {
        setNewEntry({ ...newEntry, [e.target.name]: e.target.value });
    }

    const handleQuantityClick = async (e: any) => {
        e.preventDefault();
        if (isAllDay) {
            const alert: any = new Dialog({ type: "alert", message: "Cannot edit hours when All Day is checked." });
            await alert.show();
            return;
        }
    }


    const getPtoUserInfo = () => {
        axios.get(process.env.REACT_APP_API_URL + "/api/user/getSingleUser/" + newEntry.userId, AxiosConfig.configValue())
            .then((res) => {
                setPtoUser(res.data)
            })
            .catch((err) => {
                //console.log("Get User Error", err)
            })
    }

    const addPTOLedgerEntry = async () => {
        if (newEntry.endTimets < newEntry.entryDatets) {
            const alert: any = new Dialog({ type: "alert", message: "Start date must come before end date." });
            await alert.show();
            return;
        }
        if (newEntry.ledgerEntryTypeId === null) {
            const alert: any = new Dialog({ type: "alert", message: "Please select a ledger entry type." });
            await alert.show();
            return;
        }
        //r-18-lint-dj
        //eslint-disable-next-line
        if (newEntry.quantity >= 0 && newEntry['ledgerEntryTypeId'] === 4 || newEntry.quantity >= 0 && newEntry['ledgerEntryTypeId'] === 5) {
            newEntry.quantity *= -1;
        }
        setSaving(true);
        let entryToAdd: any = { ...newEntry };
        entryToAdd.ledgerEntryTypeId = entryType.value;
        // TODO: Fix saving logic for dates
        // let entryDateElement: any = document.getElementById("entryDatePicker");
        // let endDateElement: any = document.getElementById("endDatePicker");
        //r-18-lint-dj
        //eslint-disable-next-line
        entryToAdd.entryDatets = entryToAdd.entryDatets;
        //r-18-lint-dj
        //eslint-disable-next-line
        entryToAdd.startTimets = entryToAdd.startTimets;
        //r-18-lint-dj
        //eslint-disable-next-line
        entryToAdd.endTimets = entryToAdd.endTimets;
        entryToAdd.quantity = Number(entryToAdd.quantity);
        axios.post(process.env.REACT_APP_API_URL + "/api/pto/ledger", entryToAdd, AxiosConfig.configValue("min"))
            .then(async (res: any) => {
                //cgm 050922 =>> everything in the next if statement and the setPtoData for updating front end array 
                if (sortablePtoData !== null && sortablePtoData !== undefined && res.data.LedgerEntry) {
                    let foundEntry: LedgerType | undefined = sortablePtoData.find((entry) => entry.ledgerId === res.data.LedgerEntry.ledgerId);
                    if (foundEntry !== undefined) {
                        const indexOfEntryToEdit = sortablePtoData.indexOf(foundEntry)
                        sortablePtoData[indexOfEntryToEdit] = res.data.LedgerEntry
                    }
                }
                setPtoData({ ...ptoData, ledger: sortablePtoData });

                //? Checks for allowNegative override
                if (res.data.Error?.success === false && res.data.PTOLedger?.showAllowNegativeOverride === true) {
                    let message: string = res.Error?.message || "";
                    const prompt: any = new Dialog({ type: "confirm", trueText: "Yes", falseText: "No", message: `${message} Would you like to override?` });
                    const answer: any = await prompt.show();
                    if (!answer) return;
                    setNewEntry({ ...newEntry, AllowNegativeOverride: true });
                    return;
                }
                if (Array.isArray(res.data)) {
                    if (AxiosConfig.checkArrayOfResponses(res.data, {
                        alertOnSuccess: true,
                        successMessage: "Edited Ledger Entry!",
                        showSnackbar: true,
                        snackBar: { manual: true }
                    })) {
                        //? Add res.data to ledger array
                        refreshPTOInfo();
                        closeModal();
                    }
                } else {
                    if (AxiosConfig.checkResponse(res.data, {
                        alertOnSuccess: true,
                        successMessage: "Edited Ledger Entry!",
                        showSnackbar: true,
                        snackBar: { manual: true }
                    })) {
                        closeModal();
                    }
                }
                setSaving(false);
            })
            .catch((err: any) => {
                AxiosConfig.handleError(err);
            })
            .finally(() => {
                props.refreshPTOInfo()
            })
    }

    const handleEndDateClick = async () => {
        let alert: any = new Dialog({ type: "alert", message: "Edit mode is limited to a single day. To add additional days create a new request.", trueText: "Okay" });
        await alert.show();
    }

    const changeEntryStatus = (newStatus: string) => {
        setNewEntry({ ...newEntry, status: newStatus });
    }

    React.useEffect(() => {
        let ledgerTypeId: any = toEdit?.ledgerEntryTypeId;
        if (ledgerTypeId) {
            const found = ledgerReference?.ledgerEntryTypes.find((lr: LedgerReferenceType) => lr.id === ledgerTypeId);
            if (found) {
                setEntryType({ value: found.id, label: found.text });
            }
        }
        getPtoUserInfo();
        //r-18-lint-dj
        //eslint-disable-next-line
    }, [toEdit])

    //? Code to handle allow negative override
    React.useEffect(() => {
        if (newEntry.AllowNegativeOverride) {
            addPTOLedgerEntry();
        }
        //r-18-lint-dj
        //eslint-disable-next-line
    }, [newEntry.AllowNegativeOverride])

    return (
        <>
            <Modal.Body>
                <form>
                    {
                        !isOwnPTO &&
                        <div className="d-flex flex-row align-items-center justify-content-around">
                            <Checkbox
                                name="requested"
                                label="Requested"
                                isChecked={newEntry.status === "Pending"}
                                onChange={() => changeEntryStatus("Pending")}
                                isCheckedIcon={{ icon: "pending_actions", className: "text-warning" }}

                            />
                            <Checkbox
                                name="approved"
                                label="Approve"
                                isChecked={newEntry.status === "Approved"}
                                onChange={() => changeEntryStatus("Approved")}
                                isCheckedIcon={{ icon: "check_circle", className: "text-success" }}
                            />
                            <Checkbox
                                name="denied"
                                label="Deny"
                                isChecked={newEntry.status === "Denied"}
                                onChange={() => changeEntryStatus("Denied")}
                                isCheckedIcon={{ icon: "cancel", className: "text-danger" }}
                            />
                        </div>
                    }
                    <strong className='label-spacer-edit'>Available Hours: {availableHours}</strong>
                    <Checkbox className='label-spacer-edit' onChange={handleIsAllDayToggle} isDisabled={false} isChecked={isAllDay} label={`All Day (${maxDailyPTOHours} Hours)`} />
                    <div className="d-flex flex-column col-12">
                        <strong className='label-spacer-edit'>Entry Type</strong>
                        <Select
                            defaultValue={{ label: "Select Entry Type", value: 0 }}
                            options={ledgerReference?.ledgerEntryTypes.map((lr: LedgerReferenceType) => ({ value: lr.id, label: lr.text }))}
                            value={entryType}
                            onChange={(val: any) => {
                                setEntryType(val);
                            }}
                            styles={{
                                menu: (provided: any) => ({ ...provided, zIndex: 5 })
                            }}
                        />
                        {
                            (entryType !== null && entryType !== undefined && ptoUser !== null && ptoUser !== undefined) &&
                            (entryType.value === 4 && props.userInfo.PayTypeId === 1) &&
                            <Checkbox isChecked={newEntry.IsUnplanned} onChange={() => setNewEntry({ ...newEntry, IsUnplanned: !newEntry.IsUnplanned })} label={`Time Unplanned?`} />
                        }
                    </div>
                    <div className="d-flex flex-column col-12">
                        <div className="d-flex flex-row justify-content-between align-items-center">
                            <strong className='label-spacer-edit'>Start Date</strong>
                            <strong className='label-spacer-edit'>Selected Days: {Math.round(numOfDays)}</strong>
                        </div>
                        <DatePicker
                            type="input"
                            name="entryDatets"
                            showTime={false}
                            onChange={handleDateChange}
                            isUTC={true}
                            value={newEntry.startTimets}
                            useCloseCallback
                            inputId="entryDatePicker"
                        />
                    </div>
                    <div onClick={handleEndDateClick} className="d-flex flex-column col-12">
                        <strong className='label-spacer-edit'>End Date</strong>
                        <DatePicker
                            type="input"
                            name="endDatets"
                            showTime={false}
                            onChange={handleDateChange}
                            isUTC={true}
                            value={newEntry.endTimets}
                            useCloseCallback
                            disabled
                            inputId="endDatePicker"
                        />
                    </div>
                    <div className="d-flex flex-column col-12" onClick={handleQuantityClick}>
                        <strong className='label-spacer-edit'>Hours</strong>
                        <input
                            name="quantity"
                            disabled={isAllDay}
                            type="number"
                            className="form-control"
                            value={newEntry.quantity}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="d-flex flex-column col-12">
                        <strong className='label-spacer-edit'>Comments</strong>
                        {
                            isOwnPTO ?
                                <textarea name="employeeComment" onChange={handleChange} style={{ minHeight: 150, minWidth: "50%" }} value={newEntry.employeeComment}></textarea>
                                : <textarea name="managerComment" onChange={handleChange} style={{ minHeight: 150, minWidth: "50%" }} value={newEntry.managerComment}></textarea>
                        }
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <IconButton disabled={saving} onClick={() => closeModal()} buttonClassName="action-text-danger" icon="close">Close</IconButton>
                <IconButton disabled={saving} showSpinner={saving} onClick={addPTOLedgerEntry} buttonClassName="action-text" icon="save">
                    Save
                </IconButton>
            </Modal.Footer>
        </>
    )
}

export default AddRequest;